<app-loader *ngIf="loader"></app-loader>
<section>
  <nav class="navbar navbar-expand-lg navbar-light transparent">
    <div class="col-6 p-0 d-flex align-items-center">
      <a routerLink="/more">
        <img
          src="../../../assets/img/back_button.svg"
          alt=""
          class="img-fluid navbar__img"
      /></a>
      <a class="mb-0 pl-3 pr-3 d-lg-inline-block title_get">Diagnosis</a>
    </div>
  </nav>

  <div class="container mt-3">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div *ngFor="let items of appliance" (click)="diagnosis(items._id)">
              <div
                class="row mt-3 border-bottom pb-3"
                style="cursor: pointer"
                *ngIf="items.canDiagnose === true"
              >
                <div class="col-8">
                  {{ items.applianceNickname }}
                </div>
                <div class="col-4 d-flex justify-content-end">
                  <i class="fas fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
